var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookOpen = function SvgBookOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M24 3.638A3 3 0 0 0 20.419.694l-8.42 1.917L3.583.694 3.538.685A3.002 3.002 0 0 0 0 3.638v14.328a3 3 0 0 0 2.465 2.953l9.328 1.696a1 1 0 0 0 .42 0l9.323-1.696A3 3 0 0 0 24 17.966zm-11 16.8 8.178-1.486a1 1 0 0 0 .822-.986V3.638c0-.618-.554-1.087-1.162-.988L13 4.434zM11 4.434 3.163 2.65C2.554 2.551 2 3.02 2 3.638v14.328a1 1 0 0 0 .823.985L11 20.438z",
    clipRule: "evenodd"
  })));
};
export default SvgBookOpen;